import React, { useMemo } from "react";
import { signal } from "@preact/signals-react";

import TableCell from "components/MeTable/TableCell";
import poolCell from "./poolCell";
import toolsCell from "./toolsCell";

function FactoryCell({
  record,
  field,
  parentRec,
  fieldName,
  // key,
  model,
  triggerAction,
  onClickCell,
  onChange,
  ctxView,
  level,
}) {
  const { name, component = false } = field;
  const align = toolsCell.getAlign(field);
  const value = toolsCell.getValue(field, record);
  const readOnly = toolsCell.getReadOnly(field, record, parentRec);
  const isVisible = toolsCell.getVisible(field, record);
  let color;

  const data = useMemo(() => signal(value), [record, value]);
  const attrs = {
    model,
    record,
    level,
    fieldName,
    parentRec,
    onChange,
    ctxView,
    triggerAction,
    readOnly,
    isVisible,
  };

  let _type = field.widget ?? field.type;

  const ComponentCell = poolCell[_type];
  if (!ComponentCell) {
    console.log("Type of Component there is not exist!", name, _type);
    return null;
  }
  const componentCell = (
    <ComponentCell
      // key={key}
      field={field}
      attrs={attrs}
      data={data}
      record={record}
    />
  );

  return (
    <TableCell
      // key={name}
      selectable={field.selectable}
      record={record}
      field={field.name}
      align={align}
      onClick={onClickCell}
      color={color}
    >
      {componentCell}
    </TableCell>
  );
}

export default FactoryCell;
